export default {
    CREATE_PROJECT: "Создание проекта",
    EDIT_PROJECT: "Редактирование проекта"
};
